import { render, staticRenderFns } from "./CatchWordReadingEn.vue?vue&type=template&id=cb34024e&lang=pug&"
import script from "./CatchWordReadingEn.vue?vue&type=script&lang=js&"
export * from "./CatchWordReadingEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports